// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b214537f","219":"5b3ec813","337":"d5b657c3","350":"13e8a068","453":"a5dfcc9b","760":"9949baa3"}[chunkId] + ".chunk.js";
};